import { useHistory } from "react-router-dom";
// import { QUERY_KEY } from "../constants/queryKeys";
import {  post,get } from 'helpers/api_helper';


export function useLogIn() {

  const logIn = async (email, password) => {
    try {
      // Get CSRF token first
      await get('/sanctum/csrf-cookie');  

      const data = await post('/api/admin/login', {
        email,
        password
      });
      if (data.token && data.user) {
        localStorage.setItem('authUser', JSON.stringify(data.user));
        localStorage.setItem('token', data.token);
        // if (data.user.active_parenting_space_id) {
        //   localStorage.setItem('active_parenting_space_id', data.user.active_parenting_space_id);
          window.location.href = "/";
        // } else {
        //   window.location.href = "/join_space";
        // }
      } else {
        throw new Error("Invalid response from server login.");
      }
    } catch (error) {
      throw error;
    }
  };

  return { login: logIn };
}